import I18n from 'I18n';
// Taken from https://git.hubteam.com/HubSpot/customer-data-filters/blob/4082a1441b162556f927e7c333635b8898116178/customer-data-filters-ui/static/js/converters/objectSeg/timeFilters/timeFiltersUtils.ts#L29
export const isEqualToDateOperation = operation => {
  if ((operation.propertyParser === 'VALUE' || operation.propertyParser === 'VALUE_WITH_ZONE_SAME_LOCAL_CONVERSION') && operation.operator === 'IS_BETWEEN' && operation.lowerBoundTimePoint.timeType === 'DATE' && operation.upperBoundTimePoint.timeType === 'DATE' && operation.lowerBoundEndpointBehavior === 'INCLUSIVE' && operation.upperBoundEndpointBehavior === 'INCLUSIVE') {
    const {
      lowerBoundTimePoint,
      upperBoundTimePoint
    } = operation;
    if (lowerBoundTimePoint.year === upperBoundTimePoint.year && lowerBoundTimePoint.month === upperBoundTimePoint.month && lowerBoundTimePoint.day === upperBoundTimePoint.day && lowerBoundTimePoint.hour === 0 && lowerBoundTimePoint.minute === 0 && lowerBoundTimePoint.second === 0 && lowerBoundTimePoint.millisecond === 0 && upperBoundTimePoint.hour === 23 && upperBoundTimePoint.minute === 59 && upperBoundTimePoint.second === 59 && upperBoundTimePoint.millisecond === 999) {
      return true;
    }
  }
  return false;
};
export const isBetweenDatesOperation = operation => {
  if ((operation.propertyParser === 'VALUE' || operation.propertyParser === 'VALUE_WITH_ZONE_SAME_LOCAL_CONVERSION') && operation.operator === 'IS_BETWEEN' && operation.lowerBoundTimePoint.timeType === 'DATE' && operation.upperBoundTimePoint.timeType === 'DATE' && operation.lowerBoundEndpointBehavior === 'INCLUSIVE' && operation.upperBoundEndpointBehavior === 'INCLUSIVE') {
    const {
      lowerBoundTimePoint,
      upperBoundTimePoint
    } = operation;
    if (lowerBoundTimePoint.hour === 0 && lowerBoundTimePoint.minute === 0 && lowerBoundTimePoint.second === 0 && lowerBoundTimePoint.millisecond === 0 && upperBoundTimePoint.hour === 23 && upperBoundTimePoint.minute === 59 && upperBoundTimePoint.second === 59 && upperBoundTimePoint.millisecond === 999) {
      return true;
    }
  }
  return false;
};
export const isNotBetweenDatesOperation = operation => {
  if ((operation.propertyParser === 'VALUE' || operation.propertyParser === 'VALUE_WITH_ZONE_SAME_LOCAL_CONVERSION') && operation.operator === 'IS_NOT_BETWEEN' && operation.lowerBoundTimePoint.timeType === 'DATE' && operation.upperBoundTimePoint.timeType === 'DATE' && operation.lowerBoundEndpointBehavior === 'INCLUSIVE' && operation.upperBoundEndpointBehavior === 'INCLUSIVE') {
    const {
      lowerBoundTimePoint,
      upperBoundTimePoint
    } = operation;
    if (lowerBoundTimePoint.hour === 0 && lowerBoundTimePoint.minute === 0 && lowerBoundTimePoint.second === 0 && lowerBoundTimePoint.millisecond === 0 && upperBoundTimePoint.hour === 23 && upperBoundTimePoint.minute === 59 && upperBoundTimePoint.second === 59 && upperBoundTimePoint.millisecond === 999) {
      return true;
    }
  }
  return false;
};
export const isAfterDateOperation = operation => {
  if ((operation.propertyParser === 'VALUE' || operation.propertyParser === 'VALUE_WITH_ZONE_SAME_LOCAL_CONVERSION') && 'endpointBehavior' in operation && operation.endpointBehavior === 'EXCLUSIVE' && operation.operator === 'IS_AFTER' && operation.timePoint.timeType === 'DATE' && operation.timePoint.hour === 23 && operation.timePoint.minute === 59 && operation.timePoint.second === 59 && operation.timePoint.millisecond === 999) {
    return true;
  }
  return false;
};
export const isBeforeDateOperation = operation => {
  if ((operation.propertyParser === 'VALUE' || operation.propertyParser === 'VALUE_WITH_ZONE_SAME_LOCAL_CONVERSION') && operation.operator === 'IS_BEFORE' && operation.timePoint.timeType === 'DATE' && operation.timePoint.hour === 0 && operation.timePoint.minute === 0 && operation.timePoint.second === 0 && operation.timePoint.millisecond === 0) {
    return true;
  }
  return false;
};
export const isMoreThanXDaysAgoOperation = operation => {
  if ((operation.propertyParser === 'VALUE' || operation.propertyParser === 'VALUE_WITH_ZONE_SAME_LOCAL_CONVERSION') && operation.propertyType === 'timepoint' && operation.operator === 'IS_BEFORE' && operation.timePoint.timeType === 'INDEXED' && operation.timePoint.indexReference.referenceType === 'TODAY' && operation.endpointBehavior === 'EXCLUSIVE' && operation.timePoint.offset && operation.timePoint.offset.days <= 0) {
    return true;
  }
  return false;
};
export const isMoreThanXDaysFromNowOperation = operation => {
  if ((operation.propertyParser === 'VALUE' || operation.propertyParser === 'VALUE_WITH_ZONE_SAME_LOCAL_CONVERSION') && operation.operator === 'IS_AFTER' && operation.timePoint.timeType === 'INDEXED' && operation.timePoint.indexReference.referenceType === 'TODAY' && operation.endpointBehavior === 'EXCLUSIVE' && operation.timePoint.offset && operation.timePoint.offset.days >= 0) {
    return true;
  }
  return false;
};
export const isLessThanXDaysAgoOperation = operation => {
  if ((operation.propertyParser === 'VALUE' || operation.propertyParser === 'VALUE_WITH_ZONE_SAME_LOCAL_CONVERSION') && operation.propertyType === 'rangedtime' && operation.operator === 'IS_BETWEEN' && operation.lowerBoundTimePoint.timeType === 'INDEXED' && operation.lowerBoundTimePoint.indexReference.referenceType === 'TODAY' && operation.lowerBoundEndpointBehavior === 'INCLUSIVE' && 'offset' in operation.lowerBoundTimePoint && operation.lowerBoundTimePoint.offset && operation.lowerBoundTimePoint.offset.days <= 0 && operation.upperBoundTimePoint.timeType === 'INDEXED' && operation.upperBoundTimePoint.indexReference.referenceType === 'NOW' && operation.upperBoundEndpointBehavior === 'INCLUSIVE') {
    return true;
  }
  return false;
};
export const isLessThanXDaysFromNowOperation = operation => {
  if ((operation.propertyParser === 'VALUE' || operation.propertyParser === 'VALUE_WITH_ZONE_SAME_LOCAL_CONVERSION') && operation.operator === 'IS_BETWEEN' && operation.lowerBoundTimePoint.timeType === 'INDEXED' && operation.lowerBoundTimePoint.indexReference.referenceType === 'NOW' && operation.lowerBoundEndpointBehavior === 'INCLUSIVE' && operation.upperBoundTimePoint.timeType === 'INDEXED' && operation.upperBoundTimePoint.indexReference.referenceType === 'TODAY' && operation.upperBoundEndpointBehavior === 'INCLUSIVE' && 'offset' in operation.upperBoundTimePoint && operation.upperBoundTimePoint.offset && operation.upperBoundTimePoint.offset.days >= 0) {
    return true;
  }
  return false;
};
const isValueReferencedOperation = operation => {
  if (operation.propertyParser === 'VALUE' && operation.timePoint.timeType === 'PROPERTY_REFERENCED' && operation.timePoint.referenceType === 'VALUE') {
    return true;
  }
  return false;
};
export const isAfterPropertyOperation = operation => {
  if (isValueReferencedOperation(operation) && operation.operator === 'IS_AFTER') {
    return true;
  }
  return false;
};
export const isBeforePropertyOperation = operation => {
  if (isValueReferencedOperation(operation) && operation.operator === 'IS_BEFORE') {
    return true;
  }
  return false;
};
const isUpdatedInLastXDaysOperationBase = operation => {
  if (operation.propertyParser === 'UPDATED_AT' && operation.propertyType === 'rangedtime' && operation.lowerBoundEndpointBehavior === 'INCLUSIVE' && operation.lowerBoundTimePoint.timeType === 'INDEXED' && operation.lowerBoundTimePoint.indexReference.referenceType === 'TODAY' && 'offset' in operation.lowerBoundTimePoint && operation.lowerBoundTimePoint.offset && operation.lowerBoundTimePoint.offset.days <= 0 && operation.upperBoundEndpointBehavior === 'INCLUSIVE' && operation.upperBoundTimePoint.timeType === 'INDEXED' && operation.upperBoundTimePoint.indexReference.referenceType === 'NOW') {
    return true;
  }
  return false;
};
export const isUpdatedInLastXDaysOperation = operation => {
  if (isUpdatedInLastXDaysOperationBase(operation) && operation.operator === 'IS_BETWEEN') {
    return true;
  }
  return false;
};
export const isNotUpdatedInLastXDaysOperation = operation => {
  if (isUpdatedInLastXDaysOperationBase(operation) && operation.operator === 'IS_NOT_BETWEEN') {
    return true;
  }
  return false;
};
const isPropertiesUpdatedAtComparisonOperation = operation => {
  if (operation.propertyParser === 'UPDATED_AT' && operation.timePoint.timeType === 'PROPERTY_REFERENCED' && operation.timePoint.referenceType === 'UPDATED_AT' && typeof operation.timePoint.property === 'string') {
    return true;
  }
  return false;
};
export const isUpdatedAfterPropertyOperation = operation => {
  if (isPropertiesUpdatedAtComparisonOperation(operation) && operation.operator === 'IS_AFTER') {
    return true;
  }
  return false;
};
export const isUpdatedBeforePropertyOperation = operation => {
  if (isPropertiesUpdatedAtComparisonOperation(operation) && operation.operator === 'IS_BEFORE') {
    return true;
  }
  return false;
};
const isUTCOffset = zoneId => {
  return zoneId === 'Z' || /^[-+]\d\d:\d\d$/.test(zoneId);
};
export const convertTimePointToMomentDate = timePoint => {
  if (isUTCOffset(timePoint.zoneId)) {
    return I18n.moment.utc({
      year: timePoint.year,
      month: timePoint.month - 1,
      date: timePoint.day
    }).utcOffset(timePoint.zoneId, true);
  }
  return I18n.moment.tz({
    year: timePoint.year,
    month: timePoint.month - 1,
    date: timePoint.day
  }, timePoint.zoneId);
};